import React, { useEffect, useState } from "react";

export default function Pricing() {
  const [pricing, setPricing] = useState([]);
  const [error, setError] = useState(null);
  const [showYearly, setShowYearly] = useState(false); // toggle state

  // helper to convert type -> readable label
  const getTypeLabel = (type) => {
    switch (type?.toLowerCase()) {
      case "monthly":
        return "month";
      case "weekly":
        return "week";
      case "daily":
        return "day";
      case "yearly":
        return "year";
      default:
        return type;
    }
  };

  const fetchPricingPlans = async () => {
    const url = `https://api.adoop.in/api/v2/subs/plans`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch pricing plans");
      }

      const data = await response.json();
      console.log("Pricing Plans:", data);
      setPricing(data);
    } catch (err) {
      console.error("Error fetching pricing plans:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchPricingPlans();
  }, []);

  // filter plans based on toggle
  const filteredPlans = pricing.filter((plan) => {
    if (showYearly) {
      return plan.type?.toLowerCase() === "yearly";
    } else {
      return plan.type?.toLowerCase() !== "yearly"; // monthly + weekly + daily
    }
  });

  return (
    <>
      <section className="page-banner">
        <div className="container">
          <h1 className="page-title">Pricing</h1>
          <div className="breadcrumb" style={{fontSize: "16px", fontWeight: "600"}}>
            <a href="https://adoop.in/index.html">Home</a> <span>›</span>{" "}
            <span>Pricing</span>
          </div>
        </div>
      </section>

      <div className="container">
        <section style={{ paddingTop: "50px" }}>
          <div className="row">
            <section id="pricing" className="pricing section">
              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                {/* Toggle switch */}
                <div
                  className="pricing-toggle-container mb-5"
                  data-aos="zoom-in"
                  data-aos-delay="150"
                >
                  <div className="pricing-toggle d-inline-flex align-items-center gap-3 px-3 py-2 rounded-pill">
                    <span className={`monthly ${!showYearly ? "active" : ""}`}>
                      Monthly
                    </span>
                    <label className="switch m-0">
                      <input
                        type="checkbox"
                        aria-label="Toggle pricing"
                        checked={showYearly}
                        onChange={(e) => setShowYearly(e.target.checked)}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className={`yearly ${showYearly ? "active" : ""}`}>
                      Yearly
                    </span>
                  </div>
                </div>

                {/* Plans */}
                <div className="row gy-4" style={{marginBottom:"50px"}}>
                  {filteredPlans.map((plan, index) => (
                    <div className="col-lg-4" key={plan.id}>
                      <article
                        className={`price-card h-100 ${
                          index === 1 ? "featured" : ""
                        }`}
                      >
                        <div className="card-head">
                          <span className="badge-title">{plan.name}</span>
                          <h3 className="title">{plan.name} Plan</h3>
                          <p
                            className="subtitle"
                            style={{ color: "var(--default-color)" }}
                          >
                            {plan.ads_limit}
                          </p>

                          <div className="price-wrap">
                                               <span className="price price-monthly">
  <span style={{ textDecoration: 'line-through', color: '#888', marginRight: '8px' }}>
    Rs.{plan.amount}
  </span>
  <span>
    {/* Rs.{plan.discount_amount} / {getTypeLabel(plan.type)} */}
    Rs.{plan.discount_amount}
  </span>
</span>
                           
                          </div>
                        </div>

                        <ul className="feature-list list-unstyled mb-4">
                          <li>
                            <i className="bi bi-check-circle"></i> Validity:{" "}
                            {plan.validity} days
                          </li>
                          <li>
                            <i className="bi bi-check-circle"></i> Per Day:{" "}
                            {plan.ads} ads
                          </li>
                          <li>
                            <i className="bi bi-check-circle"></i> Total Ads:{" "}
                            {plan.total_ads}
                          </li>
                          <li>
                            <i className="bi bi-check-circle"></i>Plan Type:{" "}
                            {getTypeLabel(plan.type)}
                          </li>
                        </ul>

                        <div className="cta">
                          <a
                            href="/comingSoon"
                            // href="https://mercury-uat.phonepe.com/transact/uat_v2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHBpcmVzT24iOjE3NTcwNzY0NDk3ODgsIm1lcmNoYW50SWQiOiJURVNULU0yM1pHVVM2U0JYSFUiLCJtZXJjaGFudE9yZGVySWQiOiI5YzhiMjVkMjAzMDc0OTc0YmZlNGVhZmMxOWZjNmJhMyJ9.9P6C_2XP7fjrV64i4WEU_MQPZlqRla77QSv0lYQIGDk"
                            className="btn btn-choose w-100"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Choose {plan.name}
                          </a>
                        </div>
                      </article>
                    </div>
                  ))}

                  {filteredPlans.length === 0 && (
                    <p className="text-center w-100">No plans available</p>
                  )}
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
    </>
  );
}
